export default {
  onAction: (eventAction: string, eventLabel: string, nonInteractive: boolean = true) => ({
    event: 'loadEventData',
    eventCategory: 'LiveChat',
    eventAction,
    eventLabel,
    nonInteractive,
    customMetrics: {},
    customVariables: {},
    _clear: true
  })
}
